export default "__VITE_ASSET__COaxzT$H__"